import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { FormRecognizerDocumentClient } from '../../app/api';
import { uiCmdPaneRightToggleNoText, uiCmdPaneRightClose } from '@form/cer-form-panes/cer-form-panes.service';
import { CustInvoiceView } from 'src/app/sales/cust-invoice.view';
import { CerFormView, ICerViewComponent } from '@form/cer-form-view';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';


import { CerUiIcons } from '@ui/cer-ui-icons';

const uiCmdFormRecognizeDocumentAnalyze: UiCommand = { id: 'FormRecognizeDocumentAnalyze', text: 'Analyser dokument', iconCss: CerUiIcons.layout, tooltipText: 'Send dokument til analyse', target: ".e-content", needSelection: true };
const uiCmdFormRecognizeDocumentExtract: UiCommand = { id: 'FormRecognizeDocumentExtract', text: 'Udtræk data', iconCss: CerUiIcons.form, tooltipText: 'Udtræk data opsat til genkendelse', target: ".e-content", needSelection: true };
const uiCmdFormRecognizeDocumentResultToClipboard: UiCommand = { id: 'FormRecognizeDocumentResultToClipboard', text: 'Kopier resultat', iconCss: CerUiIcons.extract, tooltipText: 'Kopier analyserede data til clipboard', target: ".e-content", needSelection: true };

export class FormRecogizerDocumentForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet) {

    // Panes
    viewSet.panes = {
      main: { visible: 'show', size: '80%', sizeSecondary: '70%' },
      bottom: { visible: 'show', size: '30%' },
      right: { visible: 'show', size: '20%' },
      orientationPrimary: 'horizontal'
    };

    const parentView = this.viewGet();
    viewSet.viewAdd(parentView);
    viewSet.viewAdd(this.viewFieldsGet(), parentView);
    
    if (this.routeOptions.parentView == null) {
      viewSet.viewAdd(this.lineViewGet(), parentView);

      CustInvoiceView.viewSetAsViews(CustInvoiceView.viewSetGet(
        parentView, { parentPrimaryKey: 'id', parentForeignKey: 'formRecognizerDocument' }, 'bottomLeft', 'bottom')).forEach(v => {
          v.paneTarget = 'bottom';
          if (v.viewMetadata.dataApiName == 'CustInvoiceLine') {
            v.paneTarget = 'right';
          }
          viewSet.viewAdd(v);
        });
    }
  }


  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.onCommandEvent = (e => this.onCommand(e));

    view.viewMetadata = {
      name: 'form-recogizer-document', dataApiName: 'FormRecognizerDocument', text: 'Dokumenter',
      primaryKey: 'id', titleFields: ['id'], allowEdit: false, allowCreate: true, allowDelete: true, baseFields: ['history']
    };
    // Fields
    view.fieldMetadata =
      [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle', allowEdit: false, visible: false, widthType: FieldWidthEnum.XS, orderBy: 'Descending' },
      { name: 'refTableId', text: 'Tabel', tooltipText: '', required: true, allowEdit: true, widthType: FieldWidthEnum.M, visible: false, visibleAdd: true },
      { name: 'refRowId', text: 'Post Id', tooltipText: '', required: true, allowEdit: true, widthType: FieldWidthEnum.M },
      { name: 'fileName', text: 'Fil', tooltipText: 'Filnavn', required: true, allowEdit: true, widthType: FieldWidthEnum.M },
      { name: 'folder', text: 'Sti', tooltipText: 'Stinavn', required: true, allowEdit: true, widthType: FieldWidthEnum.M, visible: false, visibleAdd: true },
      { fieldType: 'blobStorage', required: false, allowEdit: true },
      { name: 'formRecognizer', text: 'Formular', tooltipText: '', required: false, allowEdit: true, widthType: FieldWidthEnum.M, foreignKeyTableName: "FormRecognizer" },
      { name: 'processed', text: 'Behandlet', tooltipText: '', allowEdit: true, format: 'CheckBox' },
      { name: 'result', text: 'Resultat', tooltipText: '', required: false, allowEdit: true, widthType: FieldWidthEnum.L, visible: false }
      ];

    view.toolbarCommands = [uiCmdFormRecognizeDocumentAnalyze, uiCmdFormRecognizeDocumentExtract, uiCmdFormRecognizeDocumentResultToClipboard, uiCmdPaneRightToggleNoText];
    view.contextMenuCommands = [uiCmdFormRecognizeDocumentAnalyze, uiCmdFormRecognizeDocumentExtract, uiCmdFormRecognizeDocumentResultToClipboard];

    return view;
  }

  // Detail view
  private viewFieldsGet(): CerFormView {
    const view = new CerFormView();
    view.mandatory = true;
    view.viewMetadata = {
      name: 'form-recogizer-document-field', dataApiName: 'FormRecognizerDocumentField', text: 'Felter',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'document', titleFields: ['value'], allowEdit: true, allowCreate: true, allowDelete: true, baseFields: ['history']
    };

    // Detail  fields
    view.fieldMetadata =
      [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', allowEdit: false, visible: false, isIdentity: true, widthType: FieldWidthEnum.S },
      { name: 'field', text: 'Felt', tooltipText: 'Grundlæggende felt', widthType: FieldWidthEnum.S, foreignKeyTableName: 'FormRecognizerFieldType', orderBy: 'Ascending' },
      { name: 'value', text: 'Værdi', tooltipText: '', widthType: FieldWidthEnum.S }
      ];

    view.toolbarCommands = [uiCmdPaneRightClose];

    return view;
  }

  private lineViewGet(): CerFormView {
    const view = new CerFormView();
    view.paneTarget = 'bottom';
    view.viewMetadata = {
      name: 'form-recogizer-document-line', dataApiName: 'FormRecognizerDocumentLine', text: 'Linjer',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'document', titleFields: ['value'], allowEdit: true, allowCreate: true, allowDelete: true, baseFields: ['history']
    };
    view.fieldMetadata = [
      { name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', allowEdit: false, visible: false, isIdentity: true, widthType: FieldWidthEnum.S },
      { name: 'lineNum', text: 'Linje', tooltipText: 'Linjenr.', widthType: FieldWidthEnum.S, orderBy: 'Ascending', orderByPriority: 1 },
      { name: 'amountCur', text: 'Beløb', format: 'Amount', footerType: 'Sum' },
      { name: 'postingType', text: 'Konteringstype', tooltipText: '', widthType: FieldWidthEnum.S, foreignKeyTableName: 'VoucherPostingType' },
      { name: 'accountNum', text: 'Kontonr' },
      { name: 'transDate', text: 'Dato', format: 'DateShort' },
      { name: 'dimension', text: 'Afdeling' },
      { name: 'txt', text: 'Tekst' },
      { name: 'paymentRef', text: 'Betalingsref.' }
    ];
    return view;
  }

  // Commands
  public onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case uiCmdFormRecognizeDocumentAnalyze.id:
        this.documentAnalyze(event.appComponent);
        break
      case uiCmdFormRecognizeDocumentExtract.id:
        this.documentExtract(event.appComponent);
        break;
      case uiCmdFormRecognizeDocumentResultToClipboard.id:
        this.documentResultToClipboard(event.rowData);
        break;
    }
  }

  private documentResultToClipboard(row: any) {
    var document: any = row;
    if (document && document.result) {
      navigator.clipboard.writeText(document.result).then().catch(e => console.error(e));
    }
  }

  private documentAnalyze(c: ICerViewComponent) {
    this.process(true, true, c);
  }

  private documentExtract(c: ICerViewComponent) {
    this.process(false, true, c);
  }

  public process(doAnalyze: boolean, doExtract: boolean, c: ICerViewComponent) {
    var document: any = c.rowSelectedData();
    if (document) {
      var documentId: number = document.id;
      if (documentId) {
        const client: FormRecognizerDocumentClient = this.context.injector.get(FormRecognizerDocumentClient);
        client.process(documentId, doAnalyze, doExtract).subscribe({
          next: document => {
            if (document) {
              c?.research();
            }
          },
          error: error => {
            this.context.ui.errorApi(error);
          }
        }
        );
      }
    }
  }
}
